import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().email('Insira um e-mail válido')
});
